export default __webpack_public_path__ + "static/media/view2_week_country.31e53e5d.csv";